export enum AskAQuestionSubCategoryType {
	Unknown = 0,
	Other = 0,
	Request = 1,
	Incident = 2,
}
